"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playwrightScreenshot = exports.playwrightScreenshotResultSchema = exports.playwrightScreenshotArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.playwrightScreenshotArgsSchema = zod_1.z.object({
    url: zod_1.z
        .string()
        .describe('required: The URL to navigate to and capture a screenshot from. Supports flexible URL formats - protocol is optional and will be auto-normalized. Examples: "https://example.com", "www.example.com", "example.com", "subdomain.example.com", "example.com/path"'),
    filename: zod_1.z
        .string()
        .describe('Optional custom filename for the screenshot (without extension)')
        .nullish(),
    emitMode: common_1.emitModeSchema,
});
// Result schema
exports.playwrightScreenshotResultSchema = zod_1.z.object({
    type: zod_1.z.literal('file'),
    fileType: zod_1.z.literal('image'),
    filename: zod_1.z.string(),
    source: zod_1.z.object({
        kind: zod_1.z.union([zod_1.z.literal('raw'), zod_1.z.literal('url')]),
        value: zod_1.z.string(),
    }),
});
// Tool definition
exports.playwrightScreenshot = (0, common_1.createEmitModeToolMetadata)({
    id: 'playwrightScreenshot',
    displayName: 'Web Page Screenshot',
    displayDescription: 'Navigate to any URL and capture a full-page screenshot of the rendered content. Accepts flexible URL formats: full URLs (https://example.com), domains (example.com), subdomains (www.example.com), and paths (example.com/page). Protocol auto-added if missing.',
    category: 'search',
    color: common_1.BRAND_COLORS.BROWSER,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.BROWSER),
    icon: 'browser',
    argsSchema: exports.playwrightScreenshotArgsSchema,
}, exports.playwrightScreenshotResultSchema);
